<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">Sertifikasi
      <!-- <CButton color="info" style="float:right;margin-right:10px" class="btn-md ">Print</CButton> -->
          <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Ekspor PDF</CButton>
          <CDropdown
            toggler-text="Ekspor Excel"
            color="warning"
            class="mr-2 d-inline-block text-white float-right"
          >
            <CDropdownItem>Ekspor Semua</CDropdownItem>
            <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
          </CDropdown>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/finance/payment"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Payment Gateway</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/keanggotaan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Keanggotaan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/sertifikasi"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          style="background-color: #486ba7;"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Sertifikasi</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/pelatihan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Pelatihan</router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3">
          <div class="form-group">
            <label for>Jenis Ujian</label>
            <select class="form-control" name id>
              <option>Ujian Sertifikasi</option>
              <option>Ujian Sertifikasi</option>
              <option>Ujian Sertifikasi</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>        
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <table class="table table-special">
            <thead>
              <tr>
                <th rowspan="2">No</th>
                <th rowspan="2">Kode</th>
                <th rowspan="2">Jenis Ujian</th>
                <th rowspan="2">Nama Ujian / Workshop</th>
                <th colspan="3" class="text-center">Biaya</th>
                <th rowspan="2">Status</th>
                <th colspan="2" rowspan="2" class="text-center">Aksi</th>
              </tr>
              <tr>
                <th>Anggota AP</th>
                <th>Anggota Non AP</th>
                <th>Umum</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>HRG-1</td>
                <td>Sertifikasi</td>
                <td>RPL Workshop</td>
                <td>Rp.300.000</td>
                <td>Rp.300.000</td>
                <td>Rp.300.000</td>
                <td>
                  <i class="fa fa-check text-success" aria-hidden="true"></i>
                </td>
                <td>
                  <button class="btn btn-sm btn-success" @click="myModal = true">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <router-link to="/finance/sertifikasi/persyaratan-dokumen">
                    <button class="btn btn-sm btn-info">
                      <i class="fa fa-user" aria-hidden="true"></i>
                    </button>
                  </router-link>
                </td>
              </tr>
              <tr>
                <td scope="row">2</td>
                <td>W-1</td>
                <td>Sertifikasi</td>
                <td>RPL Workshop</td>
                <td>Rp.300.000</td>
                <td>Rp.300.000</td>
                <td>Rp.300.000</td>
                <td>
                  <i class="fa fa-check text-success" aria-hidden="true"></i>
                </td>
                <td>
                  <button class="btn btn-sm btn-success" @click="myModal = true">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <button class="btn btn-sm btn-info">
                    <i class="fa fa-user" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <td scope="row">3</td>
                <td>HRG-2</td>
                <td>Sertifikasi</td>
                <td>RPB 2001</td>
                <td>Rp.300.000</td>
                <td>Rp.300.000</td>
                <td>Rp.300.000</td>
                <td>
                  <i class="fa fa-check text-success" aria-hidden="true"></i>
                </td>
                <td>
                  <button class="btn btn-sm btn-success" @click="myModal = true">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <button class="btn btn-sm btn-info">
                    <i class="fa fa-user" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal detail -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm>
          <CRow>
            <div class="modal-body">
              <div class="d-block">
                <h5>Kode Sertifikasi</h5>
                <p class="ml-3 text-muted">Dasar 01</p>
              </div>
              <div class="d-block">
                <h5>Nama Ujian</h5>
                <p class="ml-3 text-muted">J-CPA</p>
              </div>
              <div class="d-block">
                <h5>Level Ujian</h5>
                <p class="ml-3 text-muted">Level Dasar</p>
              </div>
              <div class="d-block">
                <h5>Biaya</h5>
                <div class="row ml-1">
                  <div class="col-4 pl-0">
                    <p class="ml-3 mb-0 text-muted">Anggota AP</p>
                    <p class="ml-3 mb-0 text-muted">Anggota Non AP</p>
                    <p class="ml-3 text-muted">Anggota Umum</p>
                  </div>
                  <div class="col-4 pl-0">
                    <p class="ml-3 mb-0 text-muted">: Rp. 300.000</p>
                    <p class="ml-3 mb-0 text-muted">: Rp. 300.000</p>
                    <p class="ml-3 mb-0 text-muted">: Rp. 300.000</p>
                  </div>
                </div>
              </div>
              <div class="d-block">
                <h5>Mata Ujian</h5>
                <p class="ml-3 text-muted">APK.AAS</p>
              </div>
              <div class="d-block">
                <h5>Tanggal Ujian</h5>
                <p class="ml-3 text-muted">2019 - 06 - 19</p>
              </div>
              <div class="d-block">
                <h5>Lokasi Ujian</h5>
                <p class="ml-3 text-muted">UIN Sunan gunung jati Bandung</p>
              </div>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
export default {
  name: "Finance",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>